<template>
  <div class="badges">
    <transition-group>
      <div
        v-for="badge in badgeStore.badges"
        :key="badge.id"
        class="badge"
        :class="badge.type"
        @click="badge?.onClick"
      >
        <SvgAsset
          class="close"
          :content="closeSvg"
          @click.stop="badgeStore.hideBadge(badge.id)"
        />

        <img
          v-if="badge.icon"
          :src="badge.icon"
          alt=""
          class="icon"
        />
        <SvgAsset
          v-else-if="badge.type !== 'default'"
          class="icon"
          :content="getSvg(badge.type)"
        />

        <div
          class="content"
          v-html="badge.content"
        />
      </div>
    </transition-group>
  </div>
</template>

<script lang="ts" setup>
  import SvgAsset from '@devhacker/shared/components/SvgAsset.vue';
  import { useBadgeStore } from '~/features/badge/store';
  import closeSvg from './assets/close.svg?raw';
  import successSvg from './assets/success.svg?raw';
  import errorSvg from './assets/error.svg?raw';

  const badgeStore = useBadgeStore();

  function getSvg(badgeType: 'success' | 'error') {
    if (badgeType === 'success') return successSvg;
    if (badgeType === 'error') return errorSvg;
    return null as never;
  }
</script>

<style lang="scss" scoped>
  @use '@devhacker/shared/styles/breakpoints' as breakpoints;
  @use '@devhacker/shared/styles/device' as device;

  .badges {
    display: flex;
    flex-direction: column;
    padding: 16px;
    gap: 8px;
    max-width: 440px;
    width: 100%;
    user-select: none;

    &:empty {
      display: none;
    }

    @include breakpoints.tablet {
      padding: 16px 24px;
    }
  }

  .badge {
    position: relative;
    background: #fff;
    border: 1px solid #000;
    border-radius: 16px;
    padding: 16px 44px 16px 20px;

    @include breakpoints.tablet {
      border-radius: 32px;
    }

    &.success {
      color: #1c8920;
    }

    &.error {
      color: #ed0000;
    }
  }

  .icon {
    width: 24px;
    height: 24px;
    margin-bottom: 2px;
  }

  .close {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    right: 20px;
    top: 16px;
    width: 24px;
    height: 24px;
    cursor: pointer;
    color: #4c4c4c;

    @include device.hover {
      color: #000;
    }
  }

  .content {
    padding-top: 2px;
    font-size: 14px;
    line-height: 20px;
    font-family: $text-font--1;
  }
</style>
